export enum SalesWallType {
    PHONE = 'telephones-mobiles',
    ACCESSORY = 'accessoires',
}
